import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  
  import { ActivatedRoute, Router } from '@angular/router';
  import { DatePipe } from '@angular/common';
  
  import { AdoptionService } from '../../services/adoption.service';
  
  @Component({
    selector: 'app-adoption-detail',
    templateUrl: './adoption-detail.html',
    styleUrl: './adoption-detail.scss',
    imports: [DatePipe],
  })
  export class AdoptionDetailComponent implements OnInit {
    private adoptionService = inject(AdoptionService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private cdr = inject(ChangeDetectorRef);
  
    adoption: any = null;
    isLoading = true;
    isCompletingAdoption = false;
    showCompleteForm = false;

    definitiveStartDate = '';
    definitiveComments = '';
  
    ngOnInit(): void {
      const adoptionId =
        this.route.snapshot.paramMap.get('id');
  
      if (!adoptionId) {
        this.router.navigate(['/admin/adoptions']);
        return;
      }
  
      this.loadAdoption(adoptionId);
    }
  
    loadAdoption(id: string): void {
      this.isLoading = true;
  
      this.adoptionService
        .getAdoption(id)
        .subscribe({
          next: (response: any) => {
            console.log(
              '🟢 ADOPCIÓN RECIBIDA:',
              response,
            );
  
            this.adoption =
              response.data.document;
  
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR CARGANDO ADOPCIÓN:',
              error,
            );
  
            this.adoption = null;
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
        });
    }

    openCompleteForm(): void {
        this.showCompleteForm = true;
      
        this.definitiveStartDate = '';
        this.definitiveComments = '';
      }
      
      closeCompleteForm(): void {
        this.showCompleteForm = false;
      
        this.definitiveStartDate = '';
        this.definitiveComments = '';
      }
      
      completeAdoption(): void {
        if (
          !this.adoption?._id ||
          !this.definitiveStartDate
        ) {
          return;
        }
      
        this.isCompletingAdoption = true;
      
        this.adoptionService
          .completeAdoption(
            this.adoption._id,
            {
              definitiveStartDate:
                this.definitiveStartDate,
              definitiveComments:
                this.definitiveComments,
            },
          )
          .subscribe({
            next: (response: any) => {
              console.log(
                '🟢 ADOPCIÓN COMPLETADA:',
                response,
              );
      
              this.adoption =
                response.data.document;
      
              this.isCompletingAdoption = false;
              this.showCompleteForm = false;
      
              this.definitiveStartDate = '';
              this.definitiveComments = '';
      
              this.cdr.detectChanges();
            },
      
            error: (error) => {
              console.error(
                '🔴 ERROR COMPLETANDO ADOPCIÓN:',
                error,
              );
      
              this.isCompletingAdoption = false;
      
              this.cdr.detectChanges();
            },
          });
      }
  
    goBack(): void {
      this.router.navigate(['/admin/adoptions']);
    }
  }